import { leadFunnelWidget } from '../widgets/lead-funnel/client';
import { salesTrendWidget } from '../widgets/sales-trend/client';
import { WidgetsRegistry, type WidgetRegistration } from '@ayocore/platform/client/widgets';
import { BranchDealsWidget, SalesPlanWidget, UserDealsWidget } from './components/Widgets';
import { salesSummaryWidget } from '../widgets/sales-summary/client';

/** Компоненты CRM доступны и для прямого импорта, и через общий каталог. */
export const CRM_WIDGETS = {
  salesPlan: {
    code: 'crm.sales-plan',
    title: 'План продаж',
    Component: SalesPlanWidget,
    welcome: { key: 'crm-sales-plan', order: 10 },
  },
  userDeals: {
    code: 'crm.user-deals',
    title: 'Твои сделки',
    Component: UserDealsWidget,
    welcome: { key: 'crm-user-deals', order: 20 },
  },
  branchDeals: {
    code: 'crm.branch-deals',
    title: 'Сделки филиала',
    Component: BranchDealsWidget,
    welcome: { key: 'crm-branch-deals', order: 30 },
  },
  salesSummary: salesSummaryWidget,
  salesTrend: salesTrendWidget,
  leadFunnel: leadFunnelWidget,
} satisfies Record<string, WidgetRegistration>;

/** Вызывается из CRM bootstrap с размещением на главной странице. */
export function registerCrmWidgets(): void {
  for (const widget of Object.values(CRM_WIDGETS)) WidgetsRegistry.register(widget);
}
